/**
 * Class for Layout Selector bootstrap
 *
 * @class LayoutSelector
 * @depends jquery.js, controller.js
 */
var $ = require('jquery');
var siteadmin = require('../siteadmin');
var api = require('../api');
var LayoutSelector;

(function() {

    /**
     * the content element, it is initially null.
     * it's populated from afterFillContent method
     */
    var contentEl = null;

    /**
     * reference for within callbacks
     */
    var me = this;
    this.controllerLoaded = false;

    /* specific actions for module selector */
    this.afterFillContent = function(el, payload, contentElement) {

        contentEl = contentElement;

        /* if the JS files were not yet loaded */
        if (!LayoutSelector) {
            /* load the JS files */
            diy.util.scriptLoader(payload.data.js, function() {
                /* bootstrap the app */
                require.ensure([], function() {
                    LayoutSelector = require('../../layout-selector/layoutselector');
                    var initApp = require('../../layout-selector/initApp');
                    initApp(payload.data.layoutData, payload.data.layoutTopicData, payload.data.languageData);
                }, LAYOUT_SELECTOR_BUNDLE_NAME);
            }, function() {});
        } else {
            /* if the JS files are already loaded, bootstrap directly */
            require.ensure([], function() {
                var initApp = require('../../layout-selector/initApp');
                initApp(payload.data.layoutData, payload.data.layoutTopicData, payload.data.languageData);
            }, LAYOUT_SELECTOR_BUNDLE_NAME);
        }

        /**
         * highlight the tab
         * duplicating some code for the moment, however this is the best
         * way we currently have to integrate iframe tabs and non-iframe tabs
         * in one site admin window
         * @param id
         */
        var highlightTab = function(id) {
            var $navi = $('div.cc-sa-controller-layoutSelector header nav');
            $navi.find('li').removeClass('ui-tabs-selected ui-state-active');
            $navi.find('a').removeClass('active');

            $navi.find('li a[data-identifier="' + id + '"]').parent().addClass('ui-tabs-selected ui-state-active');
            $navi.find('li a[data-identifier="' + id + '"]').addClass('active');
        };

        var changeTab = function(id) {
            var $layoutSelectorEl = $('#cc-sa-item-layoutselector');

            var changeTabFunctions = {
                layouts: function() {
                    /* data-tab attributes ensures certain thing are visible on a tab and not on others */
                    $('#layoutselector').attr('data-tab', 'layouts');
                    /* update the tracking info, so tracking will be done in the correct tab context */
                    $('#layouts').attr('data-tracking-view', 'full');
                    /* close any open layout overlay */
                    $('#layoutselector .button-overlay-close').trigger('click');
                    /* reset any filter/sorting applied by other tabs */
                    LayoutSelector.getInstance().settings.selectedFilter = {};
                    LayoutSelector.getInstance().settings.selectedSorting = '';
                    // XXX reset pagination when changing tab
                    var scroller = diy.core.getObject(LayoutSelector.getInstance().settings.scroller);
                    if (scroller) {
                        scroller.currentPosition = scroller.currentColumn = 1;
                    }
                    LayoutSelector.getInstance().filterLayouts();
                    /* trigger a resize so everything will align nicely */
                    diy.editor.siteadmin.controllers.layoutSelector.resize();
                    return true;
                },
                bookmarks: function() {
                    $('#layoutselector').attr('data-tab', 'bookmarks');
                    $('#layouts').attr('data-tracking-view', 'favorites');
                    $('#layoutselector .button-overlay-close').trigger('click');
                    LayoutSelector.getInstance().settings.selectedFilter = 'is_bookmarked';
                    LayoutSelector.getInstance().settings.selectedSorting = '';
                    // XXX reset pagination when changing tab
                    var scroller = diy.core.getObject(LayoutSelector.getInstance().settings.scroller);
                    if (scroller) {
                        scroller.currentPosition = scroller.currentColumn = 1;
                    }
                    LayoutSelector.getInstance().filterBookmarks();
                    diy.editor.siteadmin.controllers.layoutSelector.resize();
                    return true;
                },
                recent: function() {
                    $('#layoutselector').attr('data-tab', 'recent');
                    $('#layouts').attr('data-tracking-view', 'history');
                    $('#layoutselector .button-overlay-close').trigger('click');
                    LayoutSelector.getInstance().settings.selectedFilter = {};
                    LayoutSelector.getInstance().settings.selectedSorting = 'RECENTLY';
                    // XXX reset pagination when changing tab
                    var scroller = diy.core.getObject(LayoutSelector.getInstance().settings.scroller);
                    if (scroller) {
                        scroller.currentPosition = scroller.currentColumn = 1;
                    }
                    LayoutSelector.getInstance().sortLayouts();
                    diy.editor.siteadmin.controllers.layoutSelector.resize();
                    return true;
                }
            };

            /* if we're currently on an iframe tab (example: own layout HTML/CSS or Layout Upload), we don't have a JS controller */
            if (undefined === siteadmin.getController().getControllerName()) {

                /* wait for the layout selector to initialize, and then switch to its correct tab */
                $(document).unbind('diy-editor-layoutselector-app-init').bind('diy-editor-layoutselector-app-init', function() {
                    changeTabFunctions[id]();
                    highlightTab(id);
                });

                /* load the layout selector inline tabs */
                var controller = siteadmin.getController();
                controller.load({
                    element: $layoutSelectorEl[0],
                    controller: 'layoutSelector',
                    windowBehavior: $layoutSelectorEl.attr('data-window-behavior'),
                    contentType: $layoutSelectorEl.attr('data-content-type')
                });
                /* after the loading, the event diy-editor-layoutselector-app-init will be fired, so it goes to the correct tab */
                controller.show();

                return true;
            } else {
                /* if we're switching between inline tabs */
                changeTabFunctions[id]();
                LayoutSelector.getInstance().trackLayoutSelector();
                highlightTab(id);
                return true;
            }
        };

        /* window behavior definitions */
        var windowBehaviorLayoutSelectorTabs = {
            header: {small: true},
            size: {
                width: payload.data.settings.size.width,
                height: payload.data.settings.size.height
            },
            resizable: {
                minWidth: payload.data.settings.size.minWidth,
                minHeight: payload.data.settings.size.minHeight
            },
            footer: false
        };
        var windowBehaviorLayoutOwnlayout = $.extend(true, {}, windowBehaviorLayoutSelectorTabs);
        windowBehaviorLayoutOwnlayout.resizable = {minWidth: 660};
        windowBehaviorLayoutOwnlayout.footer = {};

        /* define tabs */
        var tabs = [{
                title: payload.data.settings.labels.layouts,
                identifier: 'layouts',
                windowBehavior: windowBehaviorLayoutSelectorTabs,
                active: true,
                callback: function() {
                    return changeTab('layouts');
                }
            }, {
                title: payload.data.settings.labels.bookmarks,
                identifier: 'bookmarks',
                windowBehavior: windowBehaviorLayoutSelectorTabs,
                callback: function() {
                    return changeTab('bookmarks');
                }
            }, {
                title: payload.data.settings.labels.recent,
                identifier: 'recent',
                windowBehavior: windowBehaviorLayoutSelectorTabs,
                callback: function() {
                    return changeTab('recent');
                }
            }
        ];

        /* define tabs that are feature-based */
        if (payload.data.settings.features.ownlayout) {
            tabs.push({
                title: payload.data.settings.labels.ownlayout,
                identifier: 'ownlayout',
                url: '/app/siteadmin/layoutselector/api',
                contentType: 'iframe-local',
                windowBehavior: windowBehaviorLayoutOwnlayout,
                callback: function() {
                    highlightTab('ownlayout');
                }
            });
        }

        if (payload.data.settings.features.layoutupload) {
            tabs.push({
                title: payload.data.settings.labels.layoutupload,
                identifier: 'layoutupload',
                url: '/app/siteadmin/layoutselector/layoutlivepreview',
                windowBehavior: windowBehaviorLayoutSelectorTabs,
                callback: function() {
                    highlightTab('layoutupload');
                }
            });
        }

        /* header is small, so no text should be for title and description */
        api.updateTitle('');
        api.updateDescr('');
        api.updateNavi(tabs);
        api.updateHelpTopic('sa-layouts');
        this.controllerLoaded = true;
    };

    this.allowSwitch = function()
    {
        return this.controllerLoaded;
    };

    this.show = function() {
        if (LayoutSelector) {
            var $navi = $('div.cc-sa-controller-layoutSelector header nav');
            $navi.find('li').removeClass('ui-tabs-selected ui-state-active');
            $navi.find('a').removeClass('active');
            $navi.find('li a[data-identifier="layouts"]').parent().addClass('ui-tabs-selected ui-state-active');
            $navi.find('li a[data-identifier="layouts"]').addClass('active');

            /* data-tab attributes ensures certain thing are visible on a tab and not on others */
            $('#layoutselector').attr('data-tab', 'layouts');

            /* update the tracking info, so tracking will be done in the correct tab context */
            $('#layouts').attr('data-tracking-view', 'full');

            /* reset any filter/sorting applied by other tabs */
            var instance = LayoutSelector.getInstance();
            if (instance !== undefined) {
                //only if we find the instance
                LayoutSelector.getInstance().settings.selectedFilter = {};
                LayoutSelector.getInstance().settings.selectedSorting = '';
                LayoutSelector.getInstance().filterLayouts();
            }
            /* trigger a resize so everything will align nicely */
            me.resize();
        }
    };

    this.hide = function() {
        //LayoutSelector.getInstance().onHide();
    };

    /**
     * this resize function ensures that LS looks good
     * no matter in which tab it is
     *
     * check comment from /cms/mvc/modules/siteadmin/views/scripts/layoutselector/index.php
     * for more information on how this works
     */
    this.resize = function() {
        var $layoutsContainer = $('.layouts-container'), availableHeight = this.getAvailableHeight(false);
        if (availableHeight > 0) {
            $layoutsContainer.height(availableHeight);
        }
    };

    /**
     * gets the available height for drawing the layouts
     * @param includeSortingHeader whether to include the sorting header in the "recently" tab
     * @returns {number}
     */
    this.getAvailableHeight = function(includeSortingHeader) {
        var $container = $('div.cc-sa-controller-layoutSelector main'),
            $ls = $('#layoutselector'),
            $topbar = $ls.find('.greybar'),
            $footer = $ls.find('.footer'),
            $layoutsContainer = $('.layouts-container'), outerHeight = 0;

        if($container.is(':visible')) {
            outerHeight = $container.height()
                - ($topbar.outerHeight() || 0)
                - ($footer.outerHeight() || 0)
                - (parseInt($layoutsContainer.css('margin-top')) || 0)
                - (parseInt($layoutsContainer.css('margin-bottom')) || 0)
                - (includeSortingHeader ? $ls.find('.sorting-header').height() : 0);
        }

        return outerHeight;
    };

    return this;

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/main/controllers/layoutSelector.js
 ** module id = 742
 ** module chunks = 0
 **/